<template>
    <v-app>
        <router-view name="header"></router-view> 
        <v-main>
            <!-- <Login/> -->
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
//import { mapMutations } from "vuex";
//import Login from './views/LogIn';
import "./assets/css/style.css";
export default { 
    name: "App",
  //  components:{Login},
    data: () => ({}), 

   /// methods: {
      //  ...mapMutations(["setToken", "setUser"]),

        //getUser(token) {
            // this.$axios
            //     .get("http://localhost:8000/api/adminuser/me", {
            //         headers: {
            //             "x-auth-token": token
            //         }
            //     })
            //     .then(res => this.setUser(res.data))
            //     .catch(err => console.error(err.response.data));
        //},

    //     initialize() {
    //         const token = localStorage.getItem("token"); 

    //         if (token) {
    //             this.setToken(token);
    //             this.getUser(token);
    //         }
    //     }
    // },

    // created() {
    //     this.initialize();
    // }
};
</script>

<style>
.bb {
    border: 1px solid black;
}
.bw {
    border: 1px solid white;
}
.b-tile {
    border-radius: 0 !important;
}
.pointer {
    cursor: pointer;
}
</style>
